import tooltips from 'tippy.js';

const hideOnEsc = {
  name: 'hideOnEsc',
  defaultValue: true,
  fn({ hide }) {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        hide();
      }
    }

    return {
      onShow() {
        document.addEventListener('keydown', onKeyDown);
      },
      onHide() {
        document.removeEventListener('keydown', onKeyDown);
      },
    };
  },
};

tooltips('[data-tippy-content]', {
  offset: [0, 2],
  interactive: true,
  role: 'tooltip',
  plugins: [hideOnEsc],
});
